module.exports = new __parcel__URL__("ConfluenceStandardOfferAIModalRightSideDark.4c810671.svg").toString();